import React, { useEffect, useState } from "react";
import api, { fileUrl , formatTanggal, hitungUsia} from "@/lib/api";
import { SiswaEkskulSection } from "@/components/SiswaEkskulSection";
import Layout, { PageTitle } from "@/components/Layout";
import { NAV_GURU } from "@/lib/nav";
import { useAuth } from "@/context/AuthContext";
import { Eye, X } from "lucide-react";

export function ProfilGuru() {
  const { user } = useAuth();
  const [data, setData] = useState(null);
  useEffect(() => { (async () => { try { const { data } = await api.get(`/guru/${user.linked_id}`); setData(data); } catch (e) { console.error(e); } })(); }, [user]);
  if (!data) return <Layout nav={NAV_GURU}><PageTitle title="Profil Guru" /><div className="pp-card p-12 text-center text-slate-400 italic">Memuat…</div></Layout>;
  return (
    <Layout nav={NAV_GURU}>
      <PageTitle title="Profil Guru" />
      <section className="pp-card p-6 sm:p-8">
        <div className="flex flex-col sm:flex-row gap-6 mb-6">
          {data.foto_file_id ? <img src={fileUrl(data.foto_file_id)} alt="Foto" className="w-36 h-36 rounded-xl object-cover border border-slate-200" />
            : <div className="w-36 h-36 rounded-xl bg-slate-100 flex items-center justify-center text-slate-300 text-5xl font-bold">{data.nama[0]}</div>}
          <div className="flex-1">
            <h3 className="text-2xl font-bold">{data.nama}</h3>
            <p className="text-slate-500">{data.pendidikan_terakhir || "—"}</p>
          </div>
        </div>
        <dl className="grid sm:grid-cols-2 gap-x-6 gap-y-3 text-sm pt-6 border-t border-slate-100">
          {[
            ["Tempat/Tgl Lahir", `${data.tempat_lahir || "—"}, ${formatTanggal(data.tanggal_lahir)}`],
            ["Jenis Kelamin", data.jenis_kelamin === "L" ? "Laki-laki" : "Perempuan"],
            ["NIY", data.niy], ["NUPTK", data.nuptk || "—"], ["NRG", data.nrg || "—"],
            ["Pendidikan Terakhir", data.pendidikan_terakhir || "—"], ["TMT", data.tmt || "—"],
            ["No. Telp", data.telp || "—"], ["Email", data.email || "—"],
            ["Alamat", data.alamat || "—"],
          ].map(([k, v]) => (<div key={k}><dt className="text-xs uppercase text-slate-500">{k}</dt><dd className="text-slate-900 mt-0.5">{v}</dd></div>))}
        </dl>
      </section>
    </Layout>
  );
}

export function PendampinganGuru() {
  const [items, setItems] = useState([]);
  const [detail, setDetail] = useState(null);
  useEffect(() => { (async () => { const { data } = await api.get("/pendampingan"); setItems(data); })(); }, []);
  return (
    <Layout nav={NAV_GURU}>
      <PageTitle title="Siswa Pendampingan" />
      <section className="pp-card overflow-hidden">
        <table className="w-full text-sm" data-testid="pend-guru-table">
          <thead><tr className="pp-table-header">
            <th className="text-left px-5 py-3">Nama Siswa</th>
            <th className="text-left px-5 py-3">Ruangan</th>
            <th className="text-left px-5 py-3">Kelas</th>
            <th className="text-left px-5 py-3">Ketunaan</th>
            <th className="text-left px-5 py-3">Fase</th>
            <th className="text-right px-5 py-3">Detail</th>
          </tr></thead>
          <tbody>
            {items.length === 0 && <tr><td colSpan={6} className="text-center py-10 text-slate-400 italic">Belum ada siswa pendampingan.</td></tr>}
            {items.map(p => (
              <tr key={p.id} className="pp-row">
                <td className="px-5 py-3 font-medium">{p.nama_siswa}</td>
                <td className="px-5 py-3">{p.ruangan}</td>
                <td className="px-5 py-3">{p.kelas}</td>
                <td className="px-5 py-3 text-xs">{p.ketunaan}</td>
                <td className="px-5 py-3 text-xs font-semibold text-indigo-700" data-testid={`pend-guru-fase-${p.siswa_id}`}>{p.fase || "—"}</td>
                <td className="px-5 py-3 text-right"><button onClick={async () => { const { data: s } = await api.get(`/siswa/${p.siswa_id}`); setDetail(s); }} className="pp-btn-ghost text-xs"><Eye className="w-3.5 h-3.5" />Detail</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>
      {detail && (
        <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4" onClick={() => setDetail(null)}>
          <div className="bg-white rounded-2xl max-w-2xl w-full p-6 max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-5">
              <h3 className="text-xl font-bold">Identitas Siswa</h3>
              <button onClick={() => setDetail(null)}><X className="w-5 h-5 text-slate-400" /></button>
            </div>
            <div className="flex gap-5 mb-5">
              {detail.foto_file_id ? <img src={fileUrl(detail.foto_file_id)} className="w-24 h-24 rounded-xl object-cover" alt="" />
                : <div className="w-24 h-24 rounded-xl bg-slate-100 flex items-center justify-center text-slate-300 text-3xl font-bold">{detail.nama[0]}</div>}
              <div><div className="text-xl font-bold">{detail.nama}</div><div className="text-xs text-slate-500 font-mono">NISN: {detail.nis}</div></div>
            </div>
            <dl className="grid sm:grid-cols-2 gap-x-6 gap-y-3 text-sm">
              {[
                ["Tempat/Tgl Lahir", `${detail.tempat_lahir}, ${formatTanggal(detail.tanggal_lahir)}`],
                ["Usia", (() => { const u = detail.usia ?? hitungUsia(detail.tanggal_lahir); return u == null ? "—" : `${u} tahun`; })()],
                ["Jenis Kelamin", detail.jenis_kelamin === "L" ? "Laki-laki" : "Perempuan"],
                ["Alamat", detail.alamat],
                ["Nama Ayah", detail.nama_ayah], ["Pekerjaan Ayah", detail.pekerjaan_ayah], ["No. Telp Ayah", detail.telp_ayah],
                ["Nama Ibu", detail.nama_ibu], ["Pekerjaan Ibu", detail.pekerjaan_ibu], ["No. Telp Ibu", detail.telp_ibu],
              ].map(([k, v]) => (<div key={k}><dt className="text-xs uppercase text-slate-500">{k}</dt><dd className="text-slate-900 mt-0.5">{v || "—"}</dd></div>))}
            </dl>
            <SiswaEkskulSection siswaId={detail.id} />
          </div>
        </div>
      )}
    </Layout>
  );
}
